<div *ngIf="showName === true || showName == null" [class.mat-subheading-1]="SmallDisplay" class="nobottommargin">
    {{ greeting }}, {{ username }}
</div>
<div class="role" *ngIf="role && !user?.IsMultiRole">{{ role }}</div>
<div [hidden]="!role || !user?.IsMultiRole">
    <mat-menu #roleMenu="matMenu">
        <button mat-menu-item *ngFor="let rl of user?.Roles" (click)="SwitchRole(rl.RoleName, rl.WorkLocation)">
            <span>{{rl.RoleName | roleText}} </span>
			<span *ngIf="!rl.InSchoolGroup">({{rl.WorkLocation}})</span>
			<span *ngIf="rl.InSchoolGroup">({{rl.WorkLocationList}})</span>
        </button>
    </mat-menu>
    <button class="menutrigger" mat-flat-button color="primary" [matMenuTriggerFor]="roleMenu">
        <span>{{role }} </span>
		<span *ngIf="!user?.InSchoolGroup">({{user?.SchoolNumber}})</span>
		<span *ngIf="user?.InSchoolGroup">({{user?.SchoolNumberList}})</span>
        <mat-icon>keyboard_arrow_down</mat-icon>
    </button>
</div>
